import React, { Component } from "react";
import { connect } from "react-redux";
import { Segmented } from "antd5";
import ModalPdfCMMS from "./ModalPdfCMMS";
import etiquetaActivoCMMSPdf from "../../../../Pdf/cmms/etiquetaActivoCMMSPdf";
import { cmmsPost, urlPublicaActivo } from "../cmmsComun";

// Etiquetas de servicio con QR para uno o varios activos (props.ids).
// El QR abre la ficha publica del equipo, donde el hospital puede reportar una falla.
class ModalEtiquetasCMMS extends Component {
    state = { formato: "etiqueta", llave: 0 };

    generar = async () => {
        const res = await cmmsPost(this.props, "datosEtiquetasActivosCMMS", { ids: this.props.ids || [] });
        if (res.data.success !== 2) throw new Error(res.data.message || "No se pudieron consultar los activos");
        return etiquetaActivoCMMSPdf(res.data, { formato: this.state.formato, urlActivo: urlPublicaActivo });
    };

    render() {
        const total = (this.props.ids || []).length;
        return (
            <ModalPdfCMMS
                key={this.state.llave}
                visible={this.props.visible}
                onClose={this.props.onClose}
                titulo={
                    <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
                        <span>{total === 1 ? "Etiqueta de servicio" : `Etiquetas de servicio (${total})`}</span>
                        <Segmented
                            size="small"
                            value={this.state.formato}
                            options={[
                                { label: "Impresora de etiquetas", value: "etiqueta" },
                                { label: "Hoja carta", value: "carta" },
                            ]}
                            // Remontar el visor para regenerar con el nuevo formato.
                            onChange={(formato) => this.setState((s) => ({ formato, llave: s.llave + 1 }))}
                        />
                    </div>
                }
                nombreArchivo={total === 1 ? "Etiqueta.pdf" : "Etiquetas.pdf"}
                generar={this.generar}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalEtiquetasCMMS);
